import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import "./CarbonIntensityIndicator.scss";

import { Label, SIZING } from "abs-ui-components";

import { CARBON_INTESITY_INDICATOR_COLUMNS } from "../../../../constants/EUETS-CarbonIntensity-Indicator-headers";
import CustomTable from "../../../../common/customTable/CustomTable";
import CIIExclusionCalculation from "../../ReportData/CIIData/CIIDataForms/CIIExclusionsCalculation";
import { getCIIVoyageData } from "../../../../services/VesselEmissionsService";

const CarbonIntensityIndicator = () => {
	const [ciiData, setCiiData] = useState([]);
	const [loading, setLoading] = useState(false);
	const reportDetails = useSelector(
		(state) => state?.reports?.selectedReportDetails
	);

	useEffect(() => {
		fetchCarbonIntensityIndicatorData();
	}, []);

	const fetchCarbonIntensityIndicatorData = async () => {
		try {
			setLoading(true);
			const CIIDataResponse = await getCIIVoyageData(
				reportDetails?.ReportMstId
			);
			if (CIIDataResponse.isSuccess) {
				setCiiData(CIIDataResponse?.data?.getCiiVoyages || []);
			} else {
				console.error(CIIDataResponse.errorMessage);
			}
		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
			<CustomTable
				renderTableData={ciiData}
				columnsData={CARBON_INTESITY_INDICATOR_COLUMNS}
				customProps={{
					enableSort: false,
					header: (
						<Label
							name="Carbon Intensity Indicator"
							size={SIZING.XLARGE}
							bold={true}
						></Label>
					),
					isLoading: loading,
				}}
			/>

			<div className="mt-4">
				<CIIExclusionCalculation isVesselEmissionOverviewCII={true} />
			</div>
		</>
	);
};

export default CarbonIntensityIndicator;
